module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.name === 'goodsGrid') ? _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_vm._v("\n      设置\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.base.title),
      callback: function($$v) {
        _vm.$set(_vm.base, "title", $$v)
      },
      expression: "base.title"
    }
  })], 1), _vm._v(" "), (_vm.show_subtitle) ? _c('el-form-item', {
    attrs: {
      "label": "副标题"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.base.subtitle),
      callback: function($$v) {
        _vm.$set(_vm.base, "subtitle", $$v)
      },
      expression: "base.subtitle"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.show_space) ? _c('el-form-item', {
    attrs: {
      "label": "组件间距"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.base.padded),
      callback: function($$v) {
        _vm.$set(_vm.base, "padded", $$v)
      },
      expression: "base.padded"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.show_style) ? _c('el-form-item', {
    attrs: {
      "label": "样式"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.styleChange
    },
    model: {
      value: (_vm.config.style),
      callback: function($$v) {
        _vm.$set(_vm.config, "style", $$v)
      },
      expression: "config.style"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 'grid'
    }
  }, [_c('i', {
    staticClass: "style-icon iconfont icon-th-large"
  })]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 'grids'
    }
  }, [_c('i', {
    staticClass: "style-icon iconfont icon-th"
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.show_price) ? _c('el-form-item', {
    attrs: {
      "label": "显示价格"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.config.showPrice),
      callback: function($$v) {
        _vm.$set(_vm.config, "showPrice", $$v)
      },
      expression: "config.showPrice"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.config.style !== 'grids' && _vm.show_brand) ? _c('el-form-item', {
    attrs: {
      "label": "显示品牌"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.config.brand),
      callback: function($$v) {
        _vm.$set(_vm.config, "brand", $$v)
      },
      expression: "config.brand"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "muted content-padded"
  }, [_vm._v("显示品牌需配置商品品牌logo")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择商品"
    }
  }, [_c('draggable', {
    staticClass: "content-bottom-padded",
    attrs: {
      "options": _vm.dragItemsOptions
    },
    on: {
      "end": _vm.onEnd
    },
    model: {
      value: (_vm.items),
      callback: function($$v) {
        _vm.items = $$v
      },
      expression: "items"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "setting-item item-selected"
    }, [_c('img', {
      staticClass: "thumbnail",
      attrs: {
        "src": _vm.wximageurl + item.imgUrl,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {}, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "setting-remove",
      on: {
        "click": function($event) {
          return _vm.removeItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-trash-alt"
    })])])
  }), 0), _vm._v(" "), (!_vm.limit_num || _vm.items.length < _vm.limit_num) ? _c('el-button', {
    staticClass: "iconfont icon-cog banner-button-uploader",
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.setGoods
    }
  }, [_vm._v(" 设置商品")]) : _vm._e(), _vm._v(" "), (_vm.limit_num) ? _c('span', [_vm._v(" * 最多上传" + _vm._s(_vm.limit_num) + "个商品")]) : _vm._e()], 1)], 1)], 1)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-17dd138e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17dd138e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template_editor/goods_grid.vue
// module id = 2501
// module chunks = 0